import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMaterialUIController, setPageContent } from "context";

import {  useParams, useLocation } from "react-router-dom";
import { useGetPageBySlugQuery } from "context/pages/pageApiSlice"; 
import { setPageSliceContent, selectCurrentPage } from "context/pages/pageSlice";
import DOMPurify from 'isomorphic-dompurify';
import parse from 'html-react-parser';

import Navigation  from "components/Home/components/navigation";
import Header from "components/Home/components/header";
import Counter from "components/Home/components/counters";
import About from "components/Home/components/about";
import Blog from "components/Home/components/blog";
import Features from "components/Home/components/features";
import Project from "components/Home/components/projects";
import Accordeon from "components/Home/components/accordeon";
import FancyDivider from "components/Home/child-components/FancyDivider";
import Services from "components/Home/components/services";
import Gallery from "components/Home/components/gallery";
import Testimonials from "components/Home/components/testimonials";
import Team from "components/Home/components/team";
import Clients from "components/Home/components/clients";
import Contact from "components/Home/components/contact";
import LandingFooter from "components/Home/components/landingFooter";
import NotFound from "./Pages/notFound/components/NotFound";
import SmoothScroll from "smooth-scroll";
import SplashScreen  from "components/splash-screens/ScreenLoader";
import MDBox from "dashboard/components/MDBox";
import Footer from "components/layouts/SimpleFooter";
import CallToActionBlock from "./distributers/components/CallToActionBlock";


export const scroll = new SmoothScroll('a[href*="#"], #menu a', {
  ignore: '.ignored-scrool',
  speed: 1000,
  speedAsDuration: true,
  offset: function (anchor, toggle) { return 80 }
});

const parseContent = content => parse(DOMPurify?.sanitize(content));

const  limitTextToWords = (text, maxWords = 100)=>{
  if(typeof text !== "string" ) return "...";
  // Split the text into an array of words
  const words = text.split(' ');

  // If the number of words is less than or equal to the limit, return the original text
  if (words.length <= maxWords) {
    return text;
  }

  // Otherwise, slice the array to get the first 'maxWords' words and join them back into a string
  const limitedText = words.slice(0, maxWords).join(' ');

  // Add an ellipsis (...) to indicate that the text has been truncated
  return limitedText + '...';
}

const pattern = /^(\/(en|fr|ar))?\/?$/;

const Home = () => {
  const [controller, dispatch] = useMaterialUIController();
  const mainContent = useSelector(selectCurrentPage);
  const { pageContent, darkMode } = controller;
  const { pathname } = useLocation();
  const reduxDispatch = useDispatch();
  const { slug="", lang="" }  = useParams();

  const { data : page , isLoading ,
    isSuccess,
    isError,
    error
     } = useGetPageBySlugQuery({lang, slug }, {
      refetchOnMountOrArgChange: true,
      skip :   (slug.length !==0 &&  /^[a-z0-9éàçèùîÏ_-]+(-?[a-z0-9éàçèùîÏ_-]+)*$/i.test(slug) === false) || typeof slug !== "string"
  });
  
  useEffect(() => {

    if(window.location.href.indexOf('#') !== -1){
      
      const element = window.location.href.split('#')[1];
      setTimeout(()=>{
        var anchor = document.querySelector(`#${element}`);
        anchor && scroll.animateScroll(anchor);
      },1000);
    }

    if(isSuccess) {
      setPageContent(dispatch,page?.content);
      if(["/","/fr","/ar","/en"].includes(pathname) ){
        reduxDispatch(setPageSliceContent(page?.content));
      }
    }
  }, [isSuccess, page]);
  
  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  
  return (
        isLoading ? (<SplashScreen/>) : !isError ? (<MDBox id="home-page" sx={{ overflow : "hidden",  marginTop :  "225px" }}>
        {!isEmptyObject(pageContent) && mainContent?.Navigation?.navBar && <Navigation parseContent={parseContent}  data={{ navBar : mainContent.Navigation?.navBar, logo : mainContent.Navigation.logo?.selectedImage, menu: mainContent.Menu }}  />}
        {pageContent.Headers && <Header withMenu={Boolean(pageContent.Menu)} data={pageContent.Headers} parseContent={parseContent}  />}
        {pattern.test(pathname) && <Counter/>}
        {pageContent.About && <About homepage={pattern.test(pathname)}  data={pageContent.About} parseContent={parseContent} />}
        {pageContent.Features && <Features data={pageContent.Features} parseContent={parseContent} />}
        {pageContent.Blog && <Blog  data={pageContent.Blog} parseContent={parseContent} />}
        {pattern.test(pathname) &&<FancyDivider/>}
        {pageContent.Projects && <Project data={pageContent.Projects} parseContent={parseContent} />}
        {pageContent.Accordeon && <Accordeon data={pageContent.Accordeon} parseContent={parseContent} />}
        {pageContent.Services && <Services limitTextToWords={limitTextToWords} data={pageContent.Services} parseContent={parseContent} />}
        {pageContent.Gallery && <Gallery data={pageContent.Gallery} parseContent={parseContent} />}
        {pageContent.Testimonials && <Testimonials data={pageContent.Testimonials} parseContent={parseContent} />}
        {pageContent.Team && <Team data={pageContent.Team} parseContent={parseContent} />}
        {pageContent.Clients && <Clients data={pageContent.Clients} parseContent={parseContent}/>}
        {pageContent.Contact && <Contact data={pageContent.Contact} parseContent={parseContent} />}
        {pageContent.Contact && <LandingFooter data={pageContent.Contact} feed={pageContent.Features} limitTextToWords={limitTextToWords} about={pageContent.About} navBar={pageContent.Navigation?.navBar} logo={pageContent.Navigation.logo?.selectedImage} parseContent={parseContent}/>}
        {(mainContent && !isEmptyObject(pageContent) && !pageContent.Contact) && <Footer data={mainContent.Contact}/>}
        <CallToActionBlock />
        {isEmptyObject(pageContent) && <NotFound/>}
      </MDBox>) : ( <NotFound />)
  );
};

export default Home;
